import React from 'react';

const WarningCircle = () => {
    return (
        <>
            <circle cx='12' cy='12' r='9'></circle>
            <line x1='12' y1='8' x2='12' y2='12'></line>
            <line x1='12' y1='16' x2='12.01' y2='16'></line>
        </>
    );
};

export default WarningCircle;
